import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { useLanguage } from "../context/LanguageContext"
import AuthSceneShell, { useAuthSceneParallax } from "../components/AuthSceneShell"
import PasswordInput from "../components/PasswordInput"

export default function Login() {
  const { login, error, setError } = useAuth()
  const { t } = useLanguage()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [signedIn, setSignedIn] = useState(false)
  const shapesRef = useRef(null)

  useAuthSceneParallax(shapesRef)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      await login(email, password)
      setSignedIn(true)
    } catch (e) {
      setError(e.message)
      setLoading(false)
    }
  }

  return (
    <AuthSceneShell shapesRef={shapesRef}>
      <div className="auth-layout">
        <div className="auth-form-panel">
          <div className="auth-portal-stack w-full max-w-sm mx-auto">
            <h1 className="auth-form-title">{t("signIn")}</h1>

            <div className="auth-panel-3d auth-registration-card auth-portal-card">
              <form
                className={`auth-form${loading || signedIn ? " auth-form--busy" : ""}${signedIn ? " auth-form--success" : ""}`}
                onSubmit={onSubmit}
              >
                {error && (
                  <div className="auth-alert" role="alert">
                    <span className="auth-alert-text">{error}</span>
                    <button
                      type="button"
                      onClick={() => setError("")}
                      className="auth-alert-dismiss"
                      aria-label={t("dismiss")}
                    >
                      ×
                    </button>
                  </div>
                )}

                <div className="auth-field">
                  <label htmlFor="email">{t("email")}</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="auth-input"
                  />
                </div>

                <div className="auth-field">
                  <label htmlFor="password">{t("password")}</label>
                  <PasswordInput
                    id="password"
                    name="password"
                    required
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <p className="auth-forgot-row">
                  <Link to="/forgot-password" viewTransition className="auth-text-link">
                    {t("forgotPassword")}
                  </Link>
                </p>

                <button type="submit" disabled={loading || signedIn} aria-busy={loading} className="button-glow auth-submit">
                  {signedIn ? t("goToDashboard") : loading ? `${t("signingIn")}…` : t("signIn")}
                </button>
              </form>

              <div className="auth-form-footer">
                <p>
                  {t("dontHaveAccount")}{" "}
                  <Link to="/signup" viewTransition className="auth-text-link">
                    {t("signUp")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthSceneShell>
  )
}
